import { createAction, props } from '@ngrx/store';
import {
  ICustomerCompany,
  ICustomerRole,
  ICustomerUser,
  ImportNonStandardValueErrorType,
  INonStandardValue,
  ISettingsOutputCheck
} from '../models/settings.model';

export const GetSettingsUsersData = createAction('[Settings Users] Get users data');
export const GetSettingsUsersDataSuccess = createAction(
  '[Settings Users] Get users data success',
  props<{ users: ICustomerUser[]; roles: ICustomerRole[]; companies: ICustomerCompany[] }>()
);
export const GetSettingsUsersDataFailed = createAction('[Settings Users] Get users data failed', props<{ error: Error }>());

export interface ICreateUserByUserData {
  firstName: string;
  middleName: string;
  surname: string;
  role: string;
  email: string;
  companyId: string;
  isActive: boolean;
}
export const CreateUserByUser = createAction(
  '[Settings Users] Create user by user',
  props<{ payload: ICreateUserByUserData }>()
);
export const CreateUserByUserSuccess = createAction(
  '[Settings Users] Create user by user success',
  props<{ payload: ICustomerUser }>()
);
export const CreateUserByUserFailed = createAction('[Settings Users] Create user by user failed', props<{ error: Error }>());

export interface IUpdateUserByUser {
  id: string;
  firstName?: string;
  middleName?: string;
  surname?: string;
  role?: string;
  isActive?: string;
}
export const UpdateUserByUser = createAction(
  '[Settings Users] Update user by user',
  props<{ payload: IUpdateUserByUser }>()
);
export const UpdateUserByUserSuccess = createAction(
  '[Settings Users] Update user by user success',
  props<{ payload: ICustomerUser }>()
);
export const UpdateUserByUserFailed = createAction('[Settings Users] Update user by user failed', props<{ error: Error }>());

export const ResetUserPasswordByUser = createAction(
  '[Settings Users] Reset user password by user',
  props<{ userID; email }>()
);
export const ResetUserPasswordByUserSuccess = createAction('[Settings Users] Reset user password by user success');
export const ResetUserPasswordByUserFailed = createAction(
  '[Settings Users] Reset user password by user failed',
  props<{ error: Error }>()
);

export const GetSettingsNonStandardValues = createAction('[Settings Users] Get non standard values');
export const GetSettingsNonStandardValuesSuccess = createAction(
  '[Settings Users] Get non standard values success',
  props<{ nonStandardValues: INonStandardValue[] }>()
);
export const GetSettingsNonStandardValuesFailed = createAction(
  '[Settings Users] Get non standard values failed',
  props<{ error: Error }>()
);

export const AddNonStandardValue = createAction(
  '[Settings Non Standard Value] Add non standard value',
  props<{ nonStandardValue: Pick<INonStandardValue, 'value' | 'outputCheckKeys'> }>()
);
export const AddNonStandardValueSuccess = createAction(
  '[Settings Non Standard Value] Add non standard value success',
  props<{ nonStandardValue: INonStandardValue }>()
);
export const AddNonStandardValueFailed = createAction(
  '[Settings Non Standard Value] Add non standard value failed',
  props<{ error: Error }>()
);

export const UpdateNonStandardValue = createAction(
  '[Settings Non Standard Value] Update non standard value',
  props<{ nonStandardValue: Pick<INonStandardValue, 'value' | 'outputCheckKeys' | 'id'> }>()
);
export const UpdateNonStandardValueSuccess = createAction(
  '[Settings Non Standard Value] Update non standard value success',
  props<{ nonStandardValue: INonStandardValue }>()
);
export const UpdateNonStandardValueFailed = createAction(
  '[Settings Non Standard Value] Update non standard value failed',
  props<{ error: Error }>()
);

export const DeleteNonStandardValue = createAction(
  '[Settings Non Standard Value] Delete non standard value',
  props<{ id: string }>()
);
export const DeleteNonStandardValueSuccess = createAction(
  '[Settings Non Standard Value] Delete non standard value success',
  props<{ id: string }>()
);
export const DeleteNonStandardValueFailed = createAction(
  '[Settings Non Standard Value] Delete non standard value failed',
  props<{ error: Error }>()
);

export const ImportNonStandardValues = createAction(
  '[Settings Non Standard Value] Import non standard values',
  props<{ formData: FormData }>()
);
export const ImportNonStandardValuesSuccess = createAction(
  '[Settings Non Standard Value] Import non standard values success',
  props<{ newValues: INonStandardValue[]; importError: ImportNonStandardValueErrorType | null }>()
);
export const ImportNonStandardValuesFailed = createAction(
  '[Settings Non Standard Value] Import non standard values failed',
  props<{ error: Error }>()
);
export const ClearNonStandardValuesImportError = createAction(
  '[Settings Non Standard Value] Clear non standard values import error'
);
export const GetSettingsOutputChecks = createAction('[Settings Output checks] Get settings output checks');
export const GetSettingsOutputChecksSuccess = createAction(
  '[Settings Output checks] Get settings output checks success',
  props<{ outputChecks: ISettingsOutputCheck[] }>()
);
export const GetSettingsOutputChecksFailed = createAction(
  '[Settings Output checks] Get settings output checks failed',
  props<{ error: Error }>()
);
